<template>
  <div class="flex flex-col items-center justify-center p-3 py-16 md:p-20">
    <div class="w-full text-center sm:w-1/2 mb-7">
      <h1 class="mb-5 text-2xl font-bold text-black">
        How we can serve you and deliver your favorite food
      </h1>
      <p>
        We alwyas provide the best service for you and deliver your favorite
        food to your destination.
      </p>
    </div>
    <ul class="flex flex-row flex-wrap items-start justify-center">
      <li class="w-full p-3 text-center sm:w-1/2 md:w-1/3 mb-7">
        <img src="@/assets/images/illustrations/illustration-food-1.svg" alt="" class="w-full mb-7" />
        <h2 class="text-lg font-bold text-black">Deliver your food</h2>
        <p>Deliver your best order to your destination</p>
      </li>
      <li class="w-full p-3 text-center sm:w-1/2 md:w-1/3 mb-7">
        <img src="@/assets/images/illustrations/illustration-food-2.svg" alt="" class="w-full mb-7" />
        <h2 class="text-lg font-bold text-black">Order has arrived</h2>
        <p>Your best order has arrived at your destination</p>
      </li>
      <li class="w-full p-3 text-center sm:w-1/2 md:w-1/3 mb-7">
        <img src="@/assets/images/illustrations/illustration-food-3.svg" alt="" class="w-full mb-7" />
        <h2 class="text-lg font-bold text-black">Order ready serve</h2>
        <p>Your order has arrived and ready to be served well</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TheStepSection",
};
</script>

<style>
</style>